// src/api/types/tagTypes.ts


export enum TagTypes {
  Party = 'Party',
  Hotel = 'Hotel',
  HotelImages = 'HotelImages',
  Offer = 'Offer',
  Region = 'Region',
  RegionImages = 'RegionImages',
  Booking = 'Booking',
  Images = 'Images',
  Country = 'Country',
  CountryImages = 'CountryImages',
  Category = 'Category',
  CategoryImages = 'CategoryImages',
  List = 'List',
  Search = 'Search',
  Discount = 'Discount',
  Tag = 'Tag',
  OfferOptions = 'OfferOptions',
  Company = 'Company',
  BankAccount = 'BankAccount',
  Reservation = 'Reservation',
  Applicant = 'Applicant',
  OfferProgram = 'OfferProgram',
  ProgramTemplate = 'ProgramTemplate',
  OfferOptionsMapping = 'OfferOptionsMapping',
  OfferBoardingPlace = 'OfferBoardingPlace',
  BoardingPlaceTemplate = 'BoardingPlaceTemplate',
  ContractTemplate = 'ContractTemplate',
  Contract = 'Contract',
  Invoice = 'Invoice',
  Payment = 'Payment', // Invoice payments and refunds
  CashDocument = 'CashDocument', // KP/KW cash documents
  CashBalance = 'CashBalance',
  CashReportCycles = 'CashReportCycles',
  CashReportCycleDetails = 'CashReportCycleDetails',
  ReservationPayment = 'ReservationPayment', // Reservation payments and refunds
  InvoiceImport = 'InvoiceImport', // Invoice import jobs
  InvoiceImportHistory = 'InvoiceImportHistory',
  ExpenseInvoice = 'ExpenseInvoice', // Invoice import history list
  KsefOutgoing = 'KsefOutgoing',
  KsefOutgoingEnums = 'KsefOutgoingEnums',
  KsefOutgoingStatus = 'KsefOutgoingStatus',
  KsefIncomingStatus = 'KsefIncomingStatus',
  BankDocument = 'BankDocument',
  OfferImages = 'OfferImages',
  AccountingExport = 'AccountingExport',
  ReportsList = 'ReportsList',
}
